import axiosInstance from "../Api/AxiosInstance";

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export const getRoles = async (token: string | null, value : string |  null) => {
    if (!token) {
        console.error('No access token provided');
        throw new Error('No access token provided');
    }

    try {
        const response = await axiosInstance.get(`${API_BASE_URL}/GetRoles`);

        return response.data;
    } catch (error) {
        console.error('Error fetching getRoles:', error);
        throw error;
    }
};